import React from 'react';
import { Extension } from '@mui/icons-material';
import { useLanguage } from '../../Commun/contexts/LanguageContext';
import GenericPage from '../../Commun/components/GenericPage';
import ComponentLibrary from '../components/ComponentLibrary';
import { componentsApi } from '../services/componentsApi';
import { ComponentItem } from '../components/ComponentLibrary';
import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import RootDialogPage from '../../Commun/components/RootDialogPage';
import ComponentForm from '../components/ComponentForm';

const ComponentsPage: React.FC = () => {
    const { t } = useLanguage();
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [editingComponent, setEditingComponent] = useState<ComponentItem | null>(null);
    const [formData, setFormData] = useState<Partial<ComponentItem>>({ category: 'hardware', icon: '🔧' });
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleCreate = () => {
        setEditingComponent(null);
        setFormData({ category: 'hardware', icon: '🔧', unitPrice: 0, defaultQuantity: 1 });
        setCreateDialogOpen(true);
    };

    const handleEdit = (component: ComponentItem) => {
        setEditingComponent(component);
        setFormData(component);
        setCreateDialogOpen(true);
    };

    const handleSave = async () => {
        if (!formData.name || !formData.unitPrice) return;

        if (editingComponent) {
            await componentsApi.update({ ...editingComponent, ...formData } as ComponentItem);
        } else {
            await componentsApi.create(formData as ComponentItem);
        }
        setCreateDialogOpen(false);
        setRefreshTrigger(prev => prev + 1); // Trigger refresh in library
    };

    const handleComponentAdd = async (component: ComponentItem) => {
        // Just selecting/viewing details
        console.log("Component selected:", component);
    };

    return (
        <GenericPage
            title={t('menu.maker.components')}
            icon={<Extension />}
            footerEnabled={false}
            additionalActions={
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleCreate}
                >
                    {t('common.actions.new')}
                </Button>
            }
        >
            <ComponentLibrary
                onAddComponent={handleComponentAdd}
                hideAddButton={true}
                onEditComponent={handleEdit}
                key={refreshTrigger} // Simple way to force refresh the list
            />

            <RootDialogPage
                open={createDialogOpen}
                onClose={() => setCreateDialogOpen(false)}
                title={editingComponent ? t('common.actions.edit') : t('common.actions.new')}
                onAction={handleSave}
                actionLabel={t('common.actions.save')}
            >
                <ComponentForm formData={formData} onChange={setFormData} />
            </RootDialogPage>
        </GenericPage>
    );
};

export default ComponentsPage;
